module.exports = __webpack_public_path__ + "fonts/AmazonEmber-Regular.54d59f7.woff2";